export default __webpack_public_path__ + "static/media/two-wheeler.01a6b212.png";